import styled from "styled-components/macro";

export const ConfigImage = styled.img<ConfigurationImageProps>`
    @media (min-width: 200px) and (max-width: 720px) {
        height: 100%;
        max-height: 100%;
        max-width: unset;
        ${({ fullscreen }) => fullscreen && `width: 100%; height: 100%; object-fit: contain;`}
    }
    @media (min-width: 721px) and (max-width: 1023px) {
        max-height: 100%;
    }
    pointer-events: auto;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
    position: relative;
    ${props =>
        props.theme.configurationImage.maximize === "width"
            ? "min-width: 100%; max-width: 100%; width: max-content; max-height: unset;"
            : "min-height: 100%; max-height: 100%; height: max-content; max-width: unset;"}
    ${props => (props.isSelectableItem ? `&:hover { cursor: pointer; }` : "")}
`;

export interface ConfigurationImageProps {
    isSelectableItem?: boolean;
    fullscreen?: boolean;
}
